/** 브릿지에서 체크할 `check` query parameter 종류 */
export enum BridgeCheckType {
  /** 호텔 리뷰쓰기 지원버전인지 체크합니다. 기본값입니다. */
  HOTEL = 'HOTEL',
  /** 별도의 체크를 하지 않습니다. */
  NORMAL = 'NORMAL',
}
